import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useTriggerSharePetitionModal } from '../useTriggerSharePetitionModal';

type UseSharePetitionButtonReturn = {
	actions: { handleShareClick: (customData?: Record<string, unknown>) => Promise<void> };
};
export function useSharePetitionButton(): UseSharePetitionButtonReturn {
	const track = useTracking();
	const triggerSharePetitionModal = useTriggerSharePetitionModal();

	const handleShareClick = useCallback(
		async (customData?: Record<string, unknown>) => {
			void (customData
				? track('petition_manage_share_petition_click', customData)
				: track('petition_manage_share_petition_click'));
			await triggerSharePetitionModal();
		},
		[track, triggerSharePetitionModal],
	);

	return {
		actions: { handleShareClick },
	};
}
